import type { DataTableFilterField } from '@pesto/ui/components/DataTable/DataTable.types';
import type { ColumnDef, TableState } from '@tanstack/react-table';

import { Button, Typography } from '@pesto/ui';
import { DataTableColumnHeader } from '@pesto/ui/components/DataTable/DataTableColumnHeader';

import type { Program } from '../../../__generated__/graphql/api';

const columnIdNames = {
  programId: 'id',
  name: 'name',
  cardProgram: 'cardProgram',
};

export const useProgramsListConfig = () => {
  const programsFilterFields: DataTableFilterField<any>[] = [
    {
      label: 'Program ID',
      value: columnIdNames.programId,
      placeholder: 'Program ID search',
    },
    {
      label: 'Name',
      value: columnIdNames.name,
      placeholder: 'Name search',
    },
    {
      label: 'Card Program',
      value: columnIdNames.cardProgram,
      placeholder: 'Card Program search',
    },
  ];

  const getProgramsColumns = (handleRowClicked: (row: Program) => void): ColumnDef<Program>[] => [
    {
      id: 'view',
      header: 'Action',
      accessorKey: 'id',
      enablePinning: true,
      cell: (row) => (
        <Button onClick={() => handleRowClicked(row.cell.row.original)} variant={'outline'}>
          View
        </Button>
      ),
    },
    {
      id: columnIdNames.programId,
      header: ({ column }) => <DataTableColumnHeader column={column} title="Program ID" />,
      accessorFn: (row) => row.id,
      cell: ({ row }) => (
        <Typography variant={'body'} className={'w-auto text-nowrap'}>
          {row.original.id}
        </Typography>
      ),
    },
    {
      id: columnIdNames.name,
      header: ({ column }) => <DataTableColumnHeader column={column} title="Name" />,
      accessorFn: (row) => row.name,
      cell: ({ row }) => (
        <Typography variant={'body'} className={'w-auto text-nowrap'}>
          {row.original.name}
        </Typography>
      ),
    },
    {
      id: columnIdNames.cardProgram,
      header: ({ column }) => <DataTableColumnHeader column={column} title="Card Program" />,
      accessorFn: (row) => row.cardProgram,
      cell: ({ row }) => (
        <Typography variant={'body'} className={'w-auto text-nowrap'}>
          {row.original.cardProgram}
        </Typography>
      ),
    },
  ];

  const initialTableState: Partial<TableState> = {
    columnPinning: { left: ['view'] },
  };

  return { programsFilterFields, getProgramsColumns, initialTableState };
};
